import { DraftError } from 'types/draftError';
import { DraftErrorType } from 'types/entityType';

export const groupDraftErrorsByType = (
  errors: DraftError[] | undefined
): Partial<Record<DraftErrorType, DraftError[]>> => {
  if (!errors?.length) return {};

  return errors.reduce<Partial<Record<DraftErrorType, DraftError[]>>>((grouped, error) => {
    const type = error.errorType;
    grouped[type] = [...(grouped[type] || []), error];
    return grouped;
  }, {});
};
